/**
 * Cria o estado vazio da tabela ConfiguredLimits.
 */
const EmptyState = function()
{
	return {
		frequencySettingsIds:  [],
		tableData:             [],
		showDeleteLimitDialog: false,
		showUpdateLimitDialog: false
	};
};

/**
 * Cria o estado da tabela ConfiguredLimits.
 */
const State = function(newState = EmptyState())
{
	return {
		frequencySettingsIds:  newState.frequencySettingsIds,
		tableData:             newState.tableData,
		showDeleteLimitDialog: newState.showDeleteLimitDialog,
		showUpdateLimitDialog: newState.showUpdateLimitDialog
	};
};

export default { EmptyState, State };